export default __webpack_public_path__ + "static/media/allseis-4C.26859992.jpg";